import { render, staticRenderFns } from "./IntegrationOtherProducts.vue?vue&type=template&id=20e82c63&scoped=true"
import script from "./IntegrationOtherProducts.vue?vue&type=script&lang=ts"
export * from "./IntegrationOtherProducts.vue?vue&type=script&lang=ts"
import style0 from "./IntegrationOtherProducts.vue?vue&type=style&index=0&id=20e82c63&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20e82c63",
  null
  
)

export default component.exports